import React from 'react'

export default ({width, height}) => (
  <svg className="shape shape--notification" width={width} height={height} viewBox="0 0 24 24">
    <path d='M13.59,3.31 C17,4 19,6 19,10 L19,16 L21,18 L21,19 L3,19 L3,18 L5,16 L5,10 C5,6 7,4 10.41,3.31 L10.41,2.59 C10.41,1.71 11.12,1 12,1 C12.88,1 13.59,1.71 13.59,2.59 L13.59,3.31 Z M10.01,20.01 L13.99,20.01 C13.99,21.11 13.1,22 12,22 C10.9,22 10.01,21.11 10.01,20.01 Z M17,17 L17,10 C17,7 15.3156503,5.77403552 13.1290672,5.25616057 L12,4.98874991 L10.8709328,5.25616057 C8.68434966,5.77403552 7,7 7,10 L7,17 L17,17 Z'></path>
  </svg>
)


// WEBPACK FOOTER //
// ./src/components/Shapes/Notification.js